export const AS_SEEN_ON = [
  {
    href: 'https://techsauce.co/tech-and-biz/pdpa-for-business',
    image: '/images/Landing/logo-techsauce.png',
    alt: 'Techsauce Logo',
  },
  {
    href: 'https://www.everydaymarketing.co/business/data/cookie-consent-banner-pdpa-data-driven-marketing-cookie-wow/',
    image: '/images/Landing/logo-everyday-market.png',
    alt: 'Everyday Market Logo',
  },
  {
    href: 'https://contentshifu.com/blog/cookie-consent-banner?utm_campaign=Sponsorship&utm_content=160329008&utm_medium=social&utm_source=facebook&hss_channel=fbp-322908168042215',
    image: '/images/Landing/logo-contentshifu.png',
    alt: 'Content Shifu Logo',
  },
]
